// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2bGmhxUv0MzO7tLUfQ-UXU","icon":"_2_OsIWZ9ChG3ZYBw6DUHvb"};


//////////////////
// WEBPACK FOOTER
// ./components/Customers/presentational/UserCardLink.module.css
// module id = 2351
// module chunks = 1